import PropTypes from 'prop-types'
import { useCallback, useEffect } from 'react'
// routes
import { useRouter } from 'src/routes/hooks'
//
import keycloak from 'src/utils/keycloak'

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  const router = useRouter()

  const { isLoggedIn } = keycloak

  const check = useCallback(() => {
    if (isLoggedIn()) {
      router.replace(sessionStorage.getItem('login-redirect'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router])

  useEffect(() => {
    check()
  }, [check])

  return <>{children}</>
}

GuestGuard.propTypes = {
  children: PropTypes.node,
}
